import {Cell} from 'notebook/tables/constants/CellConstants';
import {RowDataUiData} from 'notebook/tables/constants/RowConstants';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';

export function getHeaderRow(
  headerRow: Array<string>,
  rowLabels?: Array<string> | null,
  rowLabelHeader?: string | null,
  rowUiData?: Array<RowDataUiData>
): Array<string> {
  const exportedHeaderRow: Array<string> = [];
  if (rowLabels != null) {
    exportedHeaderRow.push(rowLabelHeader || '');
  }
  exportedHeaderRow.push(...headerRow);

  if (rowUiData != null) {
    exportedHeaderRow.push('Archived');
    exportedHeaderRow.push('Archive Purpose');
  }

  return exportedHeaderRow;
}

export function maybeAddValueModifier(value: string, cell: Cell, evaluatedCell: EvaluatedCell): string {
  if (evaluatedCell.error) {
    return `${value} (VALUE ERROR)`;
  }
  if (cell.exportModifierText) {
    return `${value} (${cell.exportModifierText})`;
  }
  return value;
}
